module.exports = __webpack_public_path__ + "media/images/doc3-3ff8e17fe3e742fba9d410c0774b2fff.png";